import { get } from "lodash";
import { Small, Icon } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import icon from "src/config/icons";

import { TextInputHiddenLabel } from "./SearchInput.styled";

const SearchInput = ({
  onSearch,
  searchTerm,
  searchError,
  searchLabel,
  searchPlaceholder,
  searchErrorText,
}) => {
  const onHandleInputChange = (event) => {
    const value = get(event, "target.value");
    onSearch(value);
  };

  return (
    <>
      <TextInputHiddenLabel
        fullWidth
        label={searchLabel}
        id="cp-search"
        data-testid="cp-search"
        onChange={onHandleInputChange}
        type="text"
        placeholder={searchPlaceholder}
        value={searchTerm || ""}
      />
      {searchError && (
        <Small color="danger" fontWeight="bold" display="block" mt="s">
          <Icon icon={icon.exclamation} mr="xs" />
          {searchErrorText}
        </Small>
      )}
    </>
  );
};

SearchInput.propTypes = {
  onSearch: PropTypes.func,
  searchError: PropTypes.bool,
  searchLabel: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  searchErrorText: PropTypes.string,
  searchTerm: PropTypes.string,
};

export default SearchInput;
